import React, { useEffect, useState } from 'react';
import EventHeader from './EventHeader';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getEventFormFetchData } from '../../../redux/actions/getEventForm';
import './events.css';
import { submitEventFormAction, submitEventFormFetchData } from '../../../redux/actions/submitEventFormAction';
import Swal from 'sweetalert2';
import axios from 'axios';
import HttpService, { eventbaseurl, eventbaseurlforimages, razorpaykey } from '../../../utils/httpService';
import { submiteventform_FETCH_DATA_SUCCESS } from '../../../redux/actionType';
import logo from '../../../assets/logo.png';

const EventBooking = () => {

  const navigate = useNavigate();
  const { id } = useParams();
  const dispatch = useDispatch();
  const eventData = useSelector((state) => state.getEventFormReducer);
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [submissionStatus, setSubmissionStatus] = useState(null);
  const [isPaymentProcessing, setIsPaymentProcessing] = useState(false);

  const [responseId, setResponseId] = React.useState("");
  const [razorpay_order_id, setrazorpay_order_id] = React.useState("");
  const [razorpaySignature, setRazorpaySignature] = React.useState("");
  const [responseState, setResponseState] = React.useState([]);
  const [resgesterdid, setResgesterdid] = React.useState(null);


  // console.log("resgesterdid",resgesterdid)

const baseurlforimages = eventbaseurlforimages

  const submitEventFormReducer =  useSelector((state) => state.submitEventFormReducer);



  const loadScript = (src) => {
    return new Promise((resolve) => {
      const script = document.createElement("script");

      script.src = src;

      script.onload = () => {
        resolve(true)
      }
      script.onerror = () => {
        resolve(false)
      }

      document.body.appendChild(script);
    })
  }
// console.log("razorpaykey",razorpaykey)
  const createRazorpayOrder = (amount,resgesterdid2) => {
    let data = JSON.stringify({
      amount: amount,
      registration_id: resgesterdid2
    })

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: HttpService.createorderforpayment,
      headers: {
        'Content-Type': 'application/json'
      },
      data: data
    }

    axios.request(config)
    .then((response) => {
      // console.log(JSON.stringify(response.data))
      handleRazorpayScreen(response.data.amount , response.data.orderId , resgesterdid2)
    })
    .catch((error) => {
      // console.log("error at", error)
    })
  }

  const handleRazorpayScreen = async (amount, orderId, resgesterdid2) => {
    const res = await loadScript("https://checkout.razorpay.com/v1/checkout.js");

    if (!res) {
      alert("Razorpay SDK failed to load. Are you online?");
      return;
    }

    // Set payment processing state to true
    setIsPaymentProcessing(true);

    const options = {
      key: razorpaykey, // Replace with your Razorpay test key
      amount: amount,
      currency: 'INR',
      name: "Sandesh Event Booking",
      description: "Event Booking Payment",
      image: logo,
      order_id: orderId,
     
      callback_url : `${eventbaseurl}/payment-success/${resgesterdid2}/${amount}`,

      // handler: function (response) {
      //   setResponseId(response.razorpay_payment_id);
      //   setrazorpay_order_id(response.razorpay_order_id);
      //   setRazorpaySignature(response.razorpay_signature);

      //   // Send successful payment details to backend
      //   const paymentData = {
      //     razorpay_order_id: response.razorpay_order_id,
      //     razorpay_payment_id: response.razorpay_payment_id,
      //     razorpay_signature: response.razorpay_signature,
      //     amount: amount,
      //     registration_id: resgesterdid2, 
      //   };

      //   axios.post(HttpService.verifyPayment, paymentData, {
      //     headers: { 'Content-Type': 'application/json' }
      //   })
      //   .then((res) => {
      //     Swal.fire({
      //       title: 'Payment Successful!',
      //       text: 'Your payment has been verified.',
      //       icon: 'success',
      //       confirmButtonText: 'OK',
      //       confirmButtonColor: '#3085d6',
      //       allowOutsideClick: false,
      //     });
      //     setResponseState(res.data);
      //     setTimeout(() => navigate('/all-events'), 2000);
      //   })
      //   .catch((err) => {
      //     Swal.fire({
      //       title: 'Payment Verification Failed!',
      //       text: 'Please contact support.',
      //       icon: 'error',
      //       confirmButtonText: 'OK',
      //       confirmButtonColor: '#d33',
      //       allowOutsideClick: false,
      //     }).then(()=>{
      //       navigate('/all-events')
      //     })
      //     // console.error("Payment verification error:", err);
      //   });
      // },
      prefill: {
        name: "Test User",
        email: "test@example.com"
      },
      theme: {
        color: "#AE0A0B"
      },
      modal: {
        ondismiss: function () {
          // Reset payment processing state when modal is dismissed
          setIsPaymentProcessing(false);
          Swal.fire({
            title: 'Payment Incomplete',
            text: 'Payment incomplete. Please complete it to finish your registration.',
            icon: 'error',
            confirmButtonText: 'OK',
            confirmButtonColor: '#d33',
            allowOutsideClick: false,
          });
        }
      }
    };

    const paymentObject = new window.Razorpay(options);
    paymentObject.on('payment.failed', function (response) {
      // Reset payment processing state on failure
      setIsPaymentProcessing(false);
      
      // Send failed payment details to backend
      const failedPaymentData = {
        razorpay_order_id: response.error.metadata.order_id,
        razorpay_payment_id: response.error.metadata.payment_id,
        registration_id: resgesterdid2,
        amount: amount,
        error: response.error.description
      };
      axios.post(HttpService.verifyPayment, failedPaymentData, {
        headers: { 'Content-Type': 'application/json' }
      })
      .then((res) => {
        Swal.fire({
          title: 'Payment Failed!',
          text: 'Your payment could not be completed.',
          icon: 'error',
          confirmButtonText: 'OK',
          confirmButtonColor: '#d33',
          allowOutsideClick: false,
        });
        setResponseState(res.data);
      })
      .catch((err) => {
        Swal.fire({
          title: 'Payment Verification Failed!',
          text: 'Please contact support.',
          icon: 'error',
          confirmButtonText: 'OK',
          confirmButtonColor: '#d33',
          allowOutsideClick: false,
        });
        console.error("Failed payment verification error:", err);
      });
    });
    
    // Add event listener for successful payment
    paymentObject.on('payment.success', function (response) {
      // Reset payment processing state on success
      setIsPaymentProcessing(false);
      
      // The callback_url will handle the redirect, but we can show a success message here
      Swal.fire({
        title: 'Payment Successful!',
        text: 'Redirecting to payment confirmation...',
        icon: 'success',
        timer: 2000,
        showConfirmButton: false,
        allowOutsideClick: false,
      });
    });
    
    paymentObject.open();
  };

  useEffect(() => {
    dispatch(getEventFormFetchData(id));
  }, [dispatch, id]);

  // Check for payment status from URL parameters (callback handling)
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const paymentStatus = urlParams.get('payment_status');
    const registrationId = urlParams.get('registration_id');
    
    if (paymentStatus && registrationId) {
      setIsPaymentProcessing(false);
      
      if (paymentStatus === 'success') {
        Swal.fire({
          title: 'Payment Successful!',
          text: 'Your event registration has been completed successfully.',
          icon: 'success',
          confirmButtonText: 'OK',
          confirmButtonColor: '#3085d6',
          allowOutsideClick: false,
        }).then(() => {
          navigate('/all-events');
        });
      } else if (paymentStatus === 'failed') {
        Swal.fire({
          title: 'Payment Failed!',
          text: 'Your payment could not be completed. Please try again.',
          icon: 'error',
          confirmButtonText: 'OK',
          confirmButtonColor: '#d33',
          allowOutsideClick: false,
        });
      }
    }
  }, [navigate]);

  // Initialize formData with default values based on field types
  useEffect(() => {
    if (eventData?.data?.form?.fields) {
      const initialFormData = {};
      eventData.data.form.fields.forEach((field) => {
        if (field.type === 'checkbox') {
          initialFormData[field._id] = [];
        } else if (field.type === 'multiple_choice' || field.type === 'date_picker' || field.type === 'paragraph') {
          initialFormData[field._id] = '';
        } else {
          initialFormData[field._id] = '';
        }
      });
      setFormData(initialFormData);
    }
  }, [eventData]);

  const validateField = (field, value) => {
    if (field.required && !value) {
      return `${field.label} is required`;
    }
    if (!value) return '';

    if (field.type === 'Email') {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(value)) {
        return `${field.label} must be a valid email address`;
      }
    }

    if (field.type === 'Phone') {
      const phoneRegex = /^\d{10}$/;
      if (!phoneRegex.test(value)) {
        return `${field.label} must be exactly 10 digits`;
      }
    }

    if (field.type === 'number' || field.type === 'age') {
      const numValue = Number(value);
      if (isNaN(numValue)) return `${field.label} must be a valid number`;
      if (field.validation?.min !== undefined && numValue < field.validation.min) {
        return `${field.label} must be at least ${field.validation.min}`;
      }
      if (field.validation?.max !== undefined && numValue > field.validation.max) {
        return `${field.label} must be at most ${field.validation.max}`;
      }
    }

    if (field.type === 'text' || field.type === 'short_answer' || field.type === 'paragraph') {
      const strValue = String(value);
      if (field.validation?.min !== undefined && strValue.length < field.validation.min) {
        return `${field.label} must be at least ${field.validation.min} characters`;
      }
      if (field.validation?.max !== undefined && strValue.length > field.validation.max) {
        return `${field.label} must be at most ${field.validation.max} characters`;
      }
      if (field.validation?.pattern) {
        const pattern = new RegExp(field.validation.pattern);
        if (!pattern.test(strValue)) {
          return `${field.label} format is invalid`;
        }
      }
    }

    if (field.type === 'file' || field.type === 'file_upload' && value) {
      if (field.validation?.minSize && value.size < field.validation.minSize) {
        return `${field.label} must be at least ${field.validation.minSize} bytes`;
      }
      if (field.validation?.maxSize && value.size > field.validation.maxSize) {
        return `${field.label} must be at most ${field.validation.maxSize} bytes`;
      }
      if (field.validation?.allowedTypes && !field.validation.allowedTypes.includes(value.type)) {
        return `${field.label} must be one of: ${field.validation.allowedTypes.join(', ')}`;
      }
    }

    if (field.type === 'select' || field.type === 'dropdown') {
      const selectedCount = Array.isArray(value) ? value.length : value ? 1 : 0;
      if (field.validation?.minSelections && selectedCount < field.validation.minSelections) {
        return `Please select at least ${field.validation.minSelections} ${field.label}`;
      }
    }

    if (field.type === 'checkbox') {
      const selectedCount = Array.isArray(value) ? value.length : 0;
      if (field.required && selectedCount === 0) {
        return `Please select at least one ${field.label}`;
      }
      if (field.validation?.minSelections && selectedCount < field.validation.minSelections) {
        return `Please select at least ${field.validation.minSelections} ${field.label}`;
      }
    }

    if (field.type === 'multiple_choice') {
      if (field.required && !value) {
        return `Please select one ${field.label}`;
      }
    }

    if (field.type === 'date_picker') {
      const dateValue = new Date(value);
      if (isNaN(dateValue.getTime())) {
        return `${field.label} must be a valid date`;
      }
      if (field.validation?.min && new Date(value) < new Date(field.validation.min)) {
        return `${field.label} must be on or after ${field.validation.min}`;
      }
      if (field.validation?.max && new Date(value) > new Date(field.validation.max)) {
        return `${field.label} must be on or before ${field.validation.max}`;
      }
    }

    return '';
  };

  const handleInputChange = (fieldId, value, field) => {
    setFormData((prev) => ({
      ...prev,
      [fieldId]: value,
    }));

    const error = validateField(field, value);
    setErrors((prev) => ({
      ...prev,
      [fieldId]: error,
    }));
  };

  const handleBlur = (fieldId, field) => {
    setTouched((prev) => ({
      ...prev,
      [fieldId]: true,
    }));

    const value = formData[fieldId];
    const error = validateField(field, value);
    setErrors((prev) => ({
      ...prev,
      [fieldId]: error,
    }));
  };

  const isFieldVisible = (field) => {
    if (!field.conditional) return true;
    const { dependsOn, value } = field.conditional;
    const dependentValue = formData[dependsOn];
    if (field.type === 'number' || field.type === 'age') {
      return Number(dependentValue) <= value;
    }
    return dependentValue === value;
  };

  const renderField = (field) => {
    if (!isFieldVisible(field)) return null;

    const isTouched = touched[field._id];
    const error = errors[field._id];
    const hasError = isTouched && error;

    const renderHelperText = () => {
      const constraints = [];
      if (field.validation?.min !== undefined) constraints.push(`Min: ${field.validation.min}`);
      if (field.validation?.max !== undefined) constraints.push(`Max: ${field.validation.max}`);
      if (field.validation?.pattern) {
        constraints.push('Format: ' + (field.validation.pattern === '^[0-9]{10}$' ? '10 digits' : 'Custom format'));
      }
      if (field.validation?.allowedTypes) constraints.push(`Types: ${field.validation.allowedTypes.join(', ')}`);
      if (field.type === 'Email') constraints.push('Format: example@domain.com');
      if (field.type === 'Phone') constraints.push('Format: 10 digits');
      if (constraints.length > 0) {
        return (
          <small className="text-muted" id={`${field._id}-help`}>
            {constraints.join(' | ')}
          </small>
        );
      }
      return null;
    };

    switch (field.type) {
      case 'Email':
        return (
          <div className="mb-3">
            <input
              type="email"
              className={`form-control ${hasError ? 'is-invalid' : ''}`}
              id={field._id}
              placeholder={field.placeholder || `Enter ${field.label}`}
              value={formData[field._id] || ''}
              onChange={(e) => handleInputChange(field._id, e.target.value, field)}
              onBlur={() => handleBlur(field._id, field)}
              aria-describedby={field._id + '-help'}
            />
            {/* {renderHelperText()} */}
            {hasError && <div className="invalid-feedback">{error}</div>}
          </div>
        );
      case 'Phone':
        return (
          <div className="mb-3">
            <input
              type="tel"
              className={`form-control ${hasError ? 'is-invalid' : ''}`}
              id={field._id}
              placeholder={field.placeholder || `Enter ${field.label}`}
              value={formData[field._id] || ''}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, '').slice(0, 10);
                handleInputChange(field._id, value, field);
              }}
              onBlur={() => handleBlur(field._id, field)}
              maxLength={10}
              aria-describedby={field._id + '-help'}
            />
            {renderHelperText()}
            {hasError && <div className="invalid-feedback">{error}</div>}
          </div>
        );
      case 'text':
      case 'short_answer':
        return (
          <div className="mb-3">
            <input
              type="text"
              className={`form-control ${hasError ? 'is-invalid' : ''}`}
              id={field._id}
              placeholder={field.placeholder || `Enter ${field.label}`}
              value={formData[field._id] || ''}
              onChange={(e) => handleInputChange(field._id, e.target.value, field)}
              onBlur={() => handleBlur(field._id, field)}
              pattern={field.validation?.pattern}
              minLength={field.validation?.min}
              maxLength={field.validation?.max}
              aria-describedby={field._id + '-help'}
            />
            {renderHelperText()}
            {hasError && <div className="invalid-feedback">{error}</div>}
          </div>
        );
      case 'paragraph':
        return (
          <div className="mb-3">
            <textarea
              className={`form-control ${hasError ? 'is-invalid' : ''}`}
              id={field._id}
              placeholder={field.placeholder || `Enter ${field.label}`}
              value={formData[field._id] || ''}
              onChange={(e) => handleInputChange(field._id, e.target.value, field)}
              onBlur={() => handleBlur(field._id, field)}
              minLength={field.validation?.min}
              maxLength={field.validation?.max}
              rows={4}
              aria-describedby={field._id + '-help'}
            />
            {renderHelperText()}
            {hasError && <div className="invalid-feedback">{error}</div>}
          </div>
        );
      case 'number':
      case 'age':
        return (
          <div className="mb-3">
            <input
              type="number"
              className={`form-control ${hasError ? 'is-invalid' : ''}`}
              id={field._id}
              min={field.validation?.min}
              max={field.validation?.max}
              value={formData[field._id] || ''}
              onChange={(e) => handleInputChange(field._id, e.target.value, field)}
              onBlur={() => handleBlur(field._id, field)}
              aria-describedby={field._id + '-help'}
            />
            {renderHelperText()}
            {hasError && <div className="invalid-feedback">{error}</div>}
          </div>
        );
      case 'select':
      case 'dropdown':
        return (
          <div className="mb-3">
            <select
              className={`form-select ${hasError ? 'is-invalid' : ''}`}
              id={field._id}
              value={formData[field._id] || ''}
              onChange={(e) => handleInputChange(field._id, e.target.value, field)}
              onBlur={() => handleBlur(field._id, field)}
              multiple={field.validation?.minSelections > 1}
              aria-describedby={field._id + '-help'}
            >
              <option value="">Select {field.label}</option>
              {field.options.map((option, index) => (
                <option key={index} value={option}>
                  {option}
                </option>
              ))}
            </select>
            {renderHelperText()}
            {hasError && <div className="invalid-feedback">{error}</div>}
          </div>
        );
      case 'file':
      case 'file_upload':
        return (
          <div className="mb-3">
            <input
              type="file"
              className={`form-control ${hasError ? 'is-invalid' : ''}`}
              id={field._id}
              onChange={(e) => handleInputChange(field._id, e.target.files[0], field)}
              onBlur={() => handleBlur(field._id, field)}
              accept={field.validation?.allowedTypes?.join(',') || '*'}
              multiple={field.validation?.multiple || false}
              aria-describedby={field._id + '-help'}
            />
            {renderHelperText()}
            {hasError && <div className="invalid-feedback">{error}</div>}
          </div>
        );
      case 'checkbox':
        return (
          <div className="mb-3">
            {field.options.map((option, index) => (
              <div className="form-check" key={index}>
                <input
                  type="checkbox"
                  className={`form-check-input ${hasError ? 'is-invalid' : ''}`}
                  id={`${field._id}-${index}`}
                  value={option}
                  checked={formData[field._id]?.includes(option) || false}
                  onChange={(e) => {
                    const newValue = formData[field._id] ? [...formData[field._id]] : [];
                    if (e.target.checked) {
                      newValue.push(option);
                    } else {
                      const index = newValue.indexOf(option);
                      if (index > -1) newValue.splice(index, 1);
                    }
                    handleInputChange(field._id, newValue, field);
                  }}
                  onBlur={() => handleBlur(field._id, field)}
                />
                <label className="form-check-label" htmlFor={`${field._id}-${index}`}>
                  {option}
                </label>
              </div>
            ))}
            {renderHelperText()}
            {hasError && <div className="invalid-feedback d-block">{error}</div>}
          </div>
        );
      case 'multiple_choice':
        return (
          <div className="mb-3">
            {field.options.map((option, index) => (
              <div className="form-check" key={index}>
                <input
                  type="radio"
                  className={`form-check-input ${hasError ? 'is-invalid' : ''}`}
                  id={`${field._id}-${index}`}
                  name={field._id}
                  value={option}
                  checked={formData[field._id] === option}
                  onChange={(e) => handleInputChange(field._id, e.target.value, field)}
                  onBlur={() => handleBlur(field._id, field)}
                />
                <label className="form-check-label" htmlFor={`${field._id}-${index}`}>
                  {option}
                </label>
              </div>
            ))}
            {renderHelperText()}
            {hasError && <div className="invalid-feedback d-block">{error}</div>}
          </div>
        );
      case 'date_picker':
      case 'date_of_birth':
        return (
          <div className="mb-3">
            <input
              type="date"
              className={`form-control d-flex justify-content-between custom-date-input ${hasError ? 'is-invalid' : ''}`}
              id={field._id}
              value={formData[field._id] || ''}
              onChange={(e) => handleInputChange(field._id, e.target.value, field)}
              onBlur={() => handleBlur(field._id, field)}
              min={field.type === 'date_of_birth' ? '1900-01-01' : field.validation?.min}
              max={field.type === 'date_of_birth' ? new Date().toISOString().split('T')[0] : field.validation?.max}
              aria-describedby={field._id + '-help'}
            />
            {renderHelperText()}
            {hasError && <div className="invalid-feedback">{error}</div>}
          </div>
        );
      default:
        return null;
    }
  };

  const validateForm = () => {
    const newErrors = {};
    let isValid = true;

    eventData.data.form.fields.forEach((field) => {
      if (!isFieldVisible(field)) return;
      const value = formData[field._id];
      const error = validateField(field, value);
      if (error) {
        newErrors[field._id] = error;
        isValid = false;
      }
    });

    setErrors(newErrors);
    return isValid;
  };

  // Helper to format date from yyyy-mm-dd to dd-mm-yyyy
  function formatDateToDDMMYYYY(dateStr) {
    if (!dateStr) return '';
    const [year, month, day] = dateStr.split('-');
    return `${day}-${month}-${year}`;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Mark all fields as touched for validation
    const allTouched = {};
    eventData.data.form.fields.forEach((field) => {
      allTouched[field._id] = true;
    });
    setTouched(allTouched);

    if (validateForm()) {
      const formDataToSend = new FormData();
      formDataToSend.append('eventId', id);

      const responses = {};

      eventData.data.form.fields.forEach((field) => {
        const value = formData[field._id];
        if (field.type === 'file' || field.type === 'file_upload') {
          if (value) {
            formDataToSend.append(field.label, value); // key: field label, value: file (binary)
          }
        } else if (field.type === 'checkbox') {
          if (Array.isArray(value)) {
            responses[field.label] = value; // store as array
          }
        } else if (field.type === 'date_picker' || field.type === 'date_of_birth') {
          responses[field.label] = formatDateToDDMMYYYY(value);
        } else {
          responses[field.label] = value;
        }
      });

      formDataToSend.append('responses', JSON.stringify(responses));

      try {
        const apiResponse = await dispatch(submitEventFormFetchData(formDataToSend));  
        console.log("apiResponse",apiResponse)
        setResgesterdid(apiResponse?.registration?._id)
        const message = apiResponse?.payload?.message || 'Registration successful!';
        const fees = eventData.data.event.fees;
if (apiResponse.registration?._id !== null) {
  // const resgesterdid2 = apiResponse?.registration?._id;
  // createRazorpayOrder(fees,resgesterdid2);
// } 
        Swal.fire({
          title: "Registration successful" ?  'Registration successful!' : 'Error!',
          text: `${message} Please pay the amount of ₹ ${fees} to complete the registration.`,
          icon: "Registration successful" ?  'success' : 'error',
          confirmButtonText: `Pay Now ₹${fees}`,
          allowOutsideClick: false,
          confirmButtonColor: '#AE0A0B'
        }).then((result) => {
          if (result.isConfirmed) {
         const resgesterdid2 = apiResponse?.registration?._id;
  createRazorpayOrder(fees,resgesterdid2);
          }
        });
}
        setSubmissionStatus({ 
          type: apiResponse?.payload?.success ? 'success' : 'error', 
          message 
        });
      } catch (error) {
        setSubmissionStatus({ type: 'error', message: 'Submission failed. Please try again.' });
      }
    }
  };

  // // Helper to pass registeredId to payment
  // const createRazorpayOrderWithRegisteredId = (amount, registeredId) => {
  //   let data = JSON.stringify({ amount: amount });
  //   let config = {
  //     method: "post",
  //     maxBodyLength: Infinity,
  //     url: HttpService.createorderforpayment,
  //     headers: { 'Content-Type': 'application/json' },
  //     data: data
  //   };
  //   axios.request(config)
  //     .then((response) => {
  //       handleRazorpayScreen(response.data.amount, response.data.orderId, registeredId);
  //     })
  //     .catch((error) => {
  //       // console.log("error at", error);
  //     });
  // };

  if (eventData?.error) {
    return (
      <>
        <EventHeader />
        
        <div className="container py-5">
          <div className="alert alert-danger" role="alert">
            <h4 className="alert-heading">Error Loading Form!</h4>
            <p>There was an error loading the form data. Please try again later.</p>
            <hr />
            <p className="mb-0">
              <button className="btn btn-primary" onClick={() => navigate('/all-events')}>
                Back to Events
              </button>
            </p>
          </div>
        </div>
      </>
    );
  }

  if (!eventData?.data?.form) {
    return (
      <>
        <EventHeader />
        <div className="container py-5">
          <div className="d-flex justify-content-center">
            <div className="spinner-border text-primary" role="status" aria-label="Loading form data">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      </>
    );
  }

  const { form } = eventData.data;

  return (
    <>
      <EventHeader />
      
      {/* Payment Processing Loader */}
      {isPaymentProcessing && (
        <div className="payment-loader-overlay">
          <div className="payment-loader-container">
            <div className="spinner-border text-primary" role="status">
            </div>
            <div className="mt-3">
              <h5 className="text-white mb-2">Processing Payment...</h5>
              <p className="text-white-50 mb-0">Please wait while we process your payment. Do not close this window.</p>
            </div>
          </div>
        </div>
      )}
      
      <div className="event-container">
      <div className="container py-5">
        {submissionStatus && (
          <div className={`alert alert-${submissionStatus.type} mt-3`} role="alert">
            {submissionStatus.message}
          </div>
        )}
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2 className="fw-bold mb-4">{form.formTitle}</h2>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb" style={{backgroundColor: 'white'}}>
              <li className="breadcrumb-item">
                <a href="#" onClick={() => navigate('/event')}>
                  Home
                </a>
              </li>
              <li className="breadcrumb-item">
                <a href="#" onClick={() => navigate('/all-events')}>
                  All Events
                </a>
              </li>
              <li className="breadcrumb-item">
                <a href="#" onClick={() => navigate(`/event-detail/${id}`)}>
                  Event Details
                </a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Book Tickets
              </li>
            </ol>
          </nav>
        </div>

        <div className="booking-wrapper row g-0">
          <div className="col-md-6 bg-white p-4">
            <img
            src={eventData.data.event.media?.[0]?.url ? `${baseurlforimages}${eventData.data.event.media[0].url}` : ''}
              className="img-fluid rounded mb-3"
              alt={`${form.formTitle} image`}
            />
            <h4 className="fw-bold mb-3">{form.formTitle}</h4>
            <p className="mb-4">{form.description}</p>
          </div>

          <div className="col-md-6 p-4 highlight-box">
            <h4 className="fw-bold mb-4">Fill the Form</h4>
            <form onSubmit={handleSubmit} className="row g-3">
              {form.fields.map((field) => (
                <div className="col-md-12" key={field._id}>
                  <label htmlFor={field._id} className="form-label">
                    {field.label}
                    {field.required && <span className="text-danger">*</span>}
                  </label>
                  {renderField(field)}
                </div>
              ))}
              <div className="col-12 text-end mt-3">
                <button type="submit" className="btn btn-primary px-4 py-2">

                Register Now
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      </div>
    </>
  );
};

export default EventBooking;